import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UsersListLayer from "../components/UsersListLayer";
import TrucksPageLayer from "./TrucksPageLayer";
import { API_URL } from "..";
import DefaultTabs from "./child/DefaultTabs";
import {
  Button,
  FormGroup,
  Form,
  Row,
  Col,
  FormLabel,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Icon } from "@iconify/react";
import swal from "sweetalert";

const ViewTruckPage = () => {
    const {id} = useParams();
    const history = useNavigate();
  const [jobsData, setJobsData] = useState([]);
  const [expenseLoader, setExpenseLoader] = useState(false)
  const [uploadFileTrue, setUploadFileTrue] = useState(false)
  const [singleTruck,setSingleTruck] = useState({
    update_id:id,
    name: '',
    type:'',
    duty:'',
    manufacturer: '',
    model: '',
    year: '',
    license_plate:'',
    vin:'',
    plate_expire_date: '',
    insurance_company: '',
    policy_number: '',
    expire_date: '',
    notes: '',
    status: '',
    expenses:[],

  })
  const [recordData, setRecordData] = useState({
    truck_id: id ,
    category_title: "",
    expense_title: "",
    expense_details: "",
    amount: "",
    date: "",
    payment_method: "",
    units: "",
    odometer: "",
    attachment: null,
  });
  const [scheduleData,setScheduleData] = useState({
    truck_id: id,
    title:'',
    detailing:'',
    amount:'',
    schedule_date:'',

  })
  const [singlerecordData, setSingleRecordData] = useState({
    truck_id: id ,
    category_title: "",
    expense_title: "",
    expense_details: "",
    amount: "",
    date: "",
    payment_method: "",
    units: "",
    odometer: "",
    attachment: null,
  });
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const fetchTrucks = async () => {
   
    const apiCall = await fetch(`${API_URL}/api/truck/single/${id}`, {
      method: "GET",
    });
    const response = await apiCall.json();
    if (apiCall.status === 200) {
      console.log(response.truck);
      setSingleTruck(response.truck);
    }
  };
  useEffect(() => {
    fetchTrucks();
    fetchFiles()
  }, [1]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRecordData({ ...recordData, [name]: value });
  };
  const handleChangeEdit = (e) => {
    const { name, value } = e.target;
    setSingleRecordData({ ...singlerecordData, [name]: value });
  };

  const handleFileChange = (e) => {
    setRecordData({ ...recordData, attachment: e.target.files[0] });
  };
  const handleFileChangeEdit = (e) => {
    setSingleRecordData({ ...singlerecordData, attachment: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setExpenseLoader(true)
    const formData = new FormData();
    Object.keys(recordData).forEach((key) => {
      formData.append(key, recordData[key]);
    });

    try {
      const response = await fetch(API_URL+"/api/truck/create-expense",{method : 'POST' , body : formData },
      );
      const json = await response.json();
      setExpenseLoader(false)
      if(response.status === 201){
        setShowModal(false)
        fetchTrucks();
        setRecordData({
            truck_id: id ,
            category_title: "",
            expense_title: "",
            expense_details: "",
            amount: "",
            date: "",
            payment_method: "",
            units: "",
            odometer: "",
            attachment: null,
        })
          toast.success("You've been successfully added the expense record");
      }else{
        toast.error("Please try again.");
      }
    } catch (error) {
        setExpenseLoader(false)
      console.error("Error submitting record:", error);
    }
  };
  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    setExpenseLoader(true)
    const formData = new FormData();
    Object.keys(singlerecordData).forEach((key) => {
      formData.append(key, singlerecordData[key]);
    });
    try {
      const response = await fetch(API_URL+"/api/truck/update-expense/"+singlerecordData.id,{method : 'PUT' , body : formData },
      );
      const json = await response.json();
      setExpenseLoader(false)
      if(response.status === 200){
        setShowModalEdit(false)
        
        fetchTrucks();
        }else{
        toast.error("Please try again.");
      }
    } catch (error) {
        setExpenseLoader(false)
      console.error("Error submitting record:", error);
    }
  };
  const handleDelete = async (id) =>{
    try {
        const response = await fetch(API_URL+"/api/truck/delete-expense/"+id,{method : 'DELETE' },
        );
        const json = await response.json();
       
        if(response.status === 200){
          fetchTrucks();
          setShowModalEdit(false)
          }else{
          toast.error("Please try again.");
        }
      } catch (error) {
        console.error("Error submitting record:", error);
      }
  }

  const updateTruckData = async ()=>{
    
    const apiCall = await fetch(`${API_URL}/api/truck/single/${id}`, {
        method: "PUT",
        body:JSON.stringify(singleTruck),
        headers:{
            'Content-Type' : 'application/json'
        }
      });
      const response = await apiCall.json();
      if (apiCall.status === 200) {
        swal("Truck Information", "You successfully updated the truck information" , "success")
          fetchTrucks();
      }
  }
  const [file,setFile] = useState(null)
  const handleFile = (e) => {
    setFile(e.target.files[0]);
  };
const uploadFile = async ()=>{
            const form =  new FormData();
            form.append('file' , file);
            form.append('truck_id' , id);
            const apiCall = await fetch(API_URL+'/api/truck/attachment/upload' , {body: form,method:'POST'});
            const response = await apiCall.json();
            if(apiCall.status === 201){
                setUploadFileTrue(false);
                setFile(null)
                fetchFiles();
            }
}
const [filesData,setFileData]= useState([])
const fetchFiles = async ()=>{
            const apiCall = await fetch(API_URL+'/api/truck/attachment/'+id , {method:'GET'});
            const response = await apiCall.json();
            if(apiCall.status ==200){
                setFileData(response.data)
            }
}
const handleDeleteFiles = async(passed)=>{
    const apiCall = await fetch(API_URL+'/api/truck/attachment/'+passed , {method:'DELETE'});
            const response = await apiCall.json();
            if(apiCall.status ==200){
                fetchFiles();
            }
}
const handleDeleteTruck = async()=>{
  swal({
    title: "Are you sure you want to delete this truck?",
    text: "This action cannot be undone!",
    icon: "warning",
    buttons: ["No", "Yes"],
    dangerMode: true,
  }).then( async (willDelete) => {
    if (willDelete) {
      const apiCall = await fetch(API_URL+'/api/truck/single/'+id , {method:'DELETE'});
            const response = await apiCall.json();
            if(apiCall.status ==200){
                history('/trucks');
            }
    }
  });
   
}


  
  
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Trucks" />

        <div className="col-xxl-12">
        
          <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
          <div className=" text-end m-2" style={{
            
            }}>
            <div >
                <Button onClick={()=>updateTruckData()}>Save Changes</Button>
                <Button onClick={()=>handleDeleteTruck()} className="btn btn-danger" style={{marginLeft: 10}}>Delete Truck</Button>
            </div>
            </div>
            {/* <div className="card-header py-16 px-24 bg-base border border-end-0 border-start-0 border-top-0">
                    <h6 className="text-lg mb-0">Default Tabs </h6>
                </div> */}
            <div className="card-body p-24 pt-10">
              <ul
                className="nav bordered-tab border border-top-0 border-start-0 border-end-0 d-inline-flex nav-pills mb-16"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10 active"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    General
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-details"
                    aria-selected="false"
                  >
                    Insurance
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    Expenses
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-settings-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-settings"
                    type="button"
                    role="tab"
                    aria-controls="pills-settings"
                    aria-selected="false"
                  >
                    Odometer Log
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-files-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-files"
                    type="button"
                    role="tab"
                    aria-controls="pills-files"
                    aria-selected="false"
                  >
                    Files
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-notes-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-notes"
                    type="button"
                    role="tab"
                    aria-controls="pills-notes"
                    aria-selected="false"
                  >
                    Notes
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-maintenance-schedule-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-maintenance-schedule"
                    type="button"
                    role="tab"
                    aria-controls="pills-maintenance-schedule"
                    aria-selected="false"
                  >
                    Maintenance Schedule
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link px-16 py-10"
                    id="pills-maintenance-history-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-maintenance-history"
                    type="button"
                    role="tab"
                    aria-controls="pills-maintenance-history"
                    aria-selected="false"
                  >
                    Maintenance History
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                  tabIndex={0}
                >
                  <div>
                    <h6 className="text-lg mb-8 mt-3">General Information</h6>
                    <div className="row">
                      <div className="col-md-8 mb-3 mt-3">
                        <div className="row">
                          <div className="col-md-6">
                            <label>Name</label>
                            <input onChange={(e)=>setSingleTruck((prev)=>({...prev, name: e.target.value}))} value={singleTruck.name} type="text" className="form-control" />
                          </div>
                          <div className="col-md-3">
                            <label>Type</label>
                            <select value={singleTruck.type} onChange={(e)=>setSingleTruck((prev)=>({...prev, type: e.target.value}))} className="form-control">
                              <option value={"Unspecified"}>Unspecified</option>
                              <option value={"Wrecker"}>Wrecker</option>
                              <option value={"Flat Bed"}>Flat Bed</option>
                              <option value={"Other"}>Other</option>
                              <option value={"Service Vehicle"}>
                                Service Vehicle
                              </option>
                              <option value={"Rotator"}>Rotator</option>
                              <option value={"Tractor"}>Tractor</option>
                              <option value={"Trailer"}>Trailer</option>
                              <option value={"Container"}>Container</option>
                              <option value={"Hazmat"}>Hazmat</option>
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label>Duty</label>
                            <select value={singleTruck.duty} onChange={(e)=>setSingleTruck((prev)=>({...prev, duty: e.target.value}))} className="form-control">
                              <option value={"Unspecified"}>Unspecified</option>
                              <option value={"Medium"}>Medium</option>
                              <option value={"Heavy"}>Heavy</option>
                              <option value={"Other"}>Other</option>
                              <option value={"Light"}>Light</option>
                            </select>
                          </div>
                          <div style={{ marginTop: 20 }} />
                          <div className="col-md-6 ">
                            <label htmlFor="license_plate">
                              License Plate #
                            </label>
                            <input
                              id="license_plate"
                              type="text"
                              onChange={(e)=>setSingleTruck((prev)=>({...prev, license_plate: e.target.value}))} value={singleTruck.license_plate}
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-4 ">
                            <label htmlFor="vin">VIN</label>
                            <input
                              id="vin"
                              type="text"
                              onChange={(e)=>setSingleTruck((prev)=>({...prev, vin: e.target.value}))} value={singleTruck.vin}
                              className="form-control"
                            />
                          </div>
                          <div style={{ marginTop: 20 }} />
                          <div className="col-md-6 ">
                            <label htmlFor="manufacturer">Manufacturer</label>
                            <input
                              id="manufacturer"
                              type="text"
                              onChange={(e)=>setSingleTruck((prev)=>({...prev, manufacturer: e.target.value}))} value={singleTruck.manufacturer}
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-3 ">
                            <label htmlFor="modal">Model</label>
                            <input
                              id="modal"
                              type="text"
                              onChange={(e)=>setSingleTruck((prev)=>({...prev, model: e.target.value}))} value={singleTruck.model}
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="modalyear">Year</label>
                            <select  onChange={(e)=>setSingleTruck((prev)=>({...prev, year: e.target.value}))} value={singleTruck.year} className="form-control">
                              <option value={null}>Select</option>
                              <option value={"2021"}>2021</option>
                              <option value={"2022"}>2022</option>
                              <option value={"2023"}>2023</option>
                              <option value={"2024"}>2024</option>
                              <option value={"2025"}>2025</option>
                            </select>
                          </div>
                          <div style={{ marginTop: 20 }} />
                          <div className="col-md-6">
                            <label htmlFor="plate_expire_date">
                              Plate Expire Date
                            </label>
                            <input
                              id="plate_expire_date"
                              type="date"
                              onChange={(e)=>setSingleTruck((prev)=>({...prev, plate_expire_date: e.target.value}))} value={singleTruck.plate_expire_date}
                              className="form-control"
                            />
                          </div>
                          <div style={{ marginTop: 20 }} />
                          <div className="col-md-6">
                            <label className="mb-3" htmlFor="">
                              Truck Status
                            </label>
                            <br />
                            
                            <button onClick={()=>{
                                setSingleTruck((prev)=>({...prev, status : 'active'}))
                            }} className={`btn ${singleTruck.status === 'active' ?  "btn-success" : "btn-outline-success"}`}>Active</button>
                            &nbsp;&nbsp;
                            <button
                             onClick={()=>{
                                setSingleTruck((prev)=>({...prev, status : 'in-active'}))
                            }}
                             className={`btn ${singleTruck.status === 'in-active' ?  "btn-danger" : "btn-outline-danger"}`}>In active</button>
                        
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-details"
                  role="tabpanel"
                  aria-labelledby="pills-details-tab"
                  tabIndex={0}
                >
                  <div>
                    <h6 className="text-lg mb-8 mt-3">Insurance Information</h6>
                    <div className="row">
                      <div className="col-md-10">
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label htmlFor="insurance_company">
                              Insurance Company
                            </label>
                            <input
                              type="text"
                              id="insurance_company"
                              className="form-control"
                              value={singleTruck.insurance_company}
                              onChange={(e)=> setSingleTruck((prev)=>({...prev, insurance_company : e.target.value}))}
                            />
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="policy_no">
                              Policy Number
                            </label>
                            <input
                              type="text"
                              id="policy_no"
                              className="form-control"
                              value={singleTruck.policy_number}
                              onChange={(e)=> setSingleTruck((prev)=>({...prev, policy_number : e.target.value}))}
                            />
                          </div>
                          
                          <div className="col-md-3">
                            <label htmlFor="expire_date">
                              Expiration Date
                            </label>
                            <input
                            value={singleTruck.expire_date}
                            onChange={(e)=> setSingleTruck((prev)=>({...prev, expire_date : e.target.value}))}
                              type="date"
                              id="expire_date"
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                  tabIndex={0}
                >
                  <div>
                    {singleTruck.expenses.length !==  0 ?
                    <>
                    <h6 className="text-lg mb-8 mt-3">Expenses  <button
                          onClick={() => setShowModal(true)}
                          className="btn btn-outline-success"
                        >
                          Add New Record
                        </button></h6>
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Title/Description</th>
                                <th>Attachments</th>
                                <th>Amount</th>
                                <th>Date</th>
                               
                            </tr>
                        </thead>
                        <tbody>
                            {
                                singleTruck.expenses.length === 0 ? 
                                null : singleTruck.expenses.map((e,index)=>(
                                    <tr  key={index}>
                                        <td onClick={()=>{
                                        setSingleRecordData(e)
                                        setShowModalEdit(true)
                                    }}>
                                            <p>{e.expense_title}</p>
                                            <p>{e.expense_details}</p>
                                        </td>
                                        <td>
                                            {
                                                e.attachment_file !=="" && e.attachment_file !== null ?
                                                <a className="text-primary" href={API_URL+e.attachment_file}>File</a> : 'N/a'
                                            }
                                        </td>
                                        <td onClick={()=>{
                                        setSingleRecordData(e)
                                        setShowModalEdit(true)
                                    }}>
                                           {parseFloat(e.amount).toFixed(2)}
                                        </td>
                                        <td onClick={()=>{
                                        setSingleRecordData(e)
                                        setShowModalEdit(true)
                                    }}>
                                            {e.date}
                                        </td>
                                       
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    </>:null
                    }
                    {
                        singleTruck.expenses.length === 0 ? 

                    <div className="text-center">
                      <p className="text-center text-secondary-light mb-0">
                        No Expense Made Yet.
                      </p>
                      <center>
                        <button
                          onClick={() => setShowModal(true)}
                          className="btn btn-outline-success"
                        >
                          Add New Record
                        </button>
                      </center>
                    </div>:null
                    }
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-settings"
                  role="tabpanel"
                  aria-labelledby="pills-settings-tab"
                  tabIndex={0}
                >
                  <div>
                    <h6 className="text-lg mb-8 mt-3">Odometer Log</h6>

                    <p className="text-secondary-light mb-0">
                      This feature is coming soon.
                    </p>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-files"
                  role="tabpanel"
                  aria-labelledby="pills-files-tab"
                  tabIndex={0}
                >
                  <div>
                    <div className="row">
                        <div className="col-md-6">
                        <h6 className="text-lg mb-8">Files </h6>
                        </div>
                        <div className="col-md-6 text-end">
                           <button onClick={()=>setUploadFileTrue(!uploadFileTrue)} className="btn btn-success">Upload File</button>
                        </div>
                    </div>
                  {
                    uploadFileTrue === true ?
                    <div className="row">
                    <div className="col-md-8">
                        <input type="file" onChange={handleFile} className="form-control" />
                    </div>
                    <div className="col-md-4">
                    <button onClick={()=>uploadFile()} className="btn btn-success">Submit</button>
                    </div>
                </div>: null 
                  }
                   
                    {
                        filesData.length === 0?  null : 
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filesData.map((e)=>(
                                        <tr>
                                            <td>
                                                <a  href={API_URL+e.file_url}>Download Here</a>
                                            </td>
                                            <td>
                                                {e.createdAt}
                                            </td>
                                            <td>
                                            <i class="ph ph-trash" onClick={()=>handleDeleteFiles(e.id)}></i>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    }
                  {
                    filesData.length === 0 ?
                    <p className="mt-3 text-center text-secondary-light mb-16">
                    No file found yet.
                   </p>: null
                  }
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-notes"
                  role="tabpanel"
                  aria-labelledby="pills-notes-tab"
                  tabIndex={0}
                >
                  <div>
                    <h6 className="text-lg mb-8 mt-3">Notes</h6>
                   <div className="row">
                    <div className="col-md-12">
                        <textarea rows={6} value={singleTruck.notes} onChange={(e)=>setSingleTruck((prev)=>({...prev, notes: e.target.value}))} className="form-control"></textarea>
                    </div>
                   </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-maintenance-schedule"
                  role="tabpanel"
                  aria-labelledby="pills-maintenance-schedule-tab"
                  tabIndex={0}
                >
                  <div>
                    <div className="row">
                        <div className="col-md-6">
                        <h6 className="text-lg mb-8">Schedule Maintenance </h6>
                        </div>
                        <div className="col-md-6 text-end">
                           <button onClick={()=>setScheduleModal(true)} className="btn btn-success">Schedule Service</button>
                        </div>
                    </div>
                   
                    <p className="text-center text-secondary-light mb-0">
                       No history found.
                    </p>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-maintenance-history"
                  role="tabpanel"
                  aria-labelledby="pills-maintenance-history-tab"
                  tabIndex={0}
                >
                  <div>
                  <div className="row">
                        <div className="col-md-6">
                        <h6 className="text-lg mb-8">Maintenance History </h6>
                        </div>
                        <div className="col-md-6 text-end">
                           <button onClick={()=>setScheduleModal(true)} className="btn btn-success">Add Record</button>
                        </div>
                    </div>
                   
                    <p className="text-center text-secondary-light mb-0">
                       No history found.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
        </div>

        {/* Expense Modal */}
        <Modal
          style={{zIndex:9999}}
          show={showModal}
          onHide={() => setShowModal(!showModal)}
          centered
        
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h6>Add New Record</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Category</Form.Label>
                    <Form.Select
                      name="category_title"
                      value={recordData.category_title}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Category</option>
                      <option value="Fuel">Fuel</option>
                      <option value="Maintenance">Maintenance</option>
                      <option value="Repairs">Repairs</option>
                      <option value="Wash">Wash</option>
                      <option value="Tolls">Tolls</option>
                      <option value="Misc">Misc</option>
                      <option value="Preventative Maintenance">
                        Preventative Maintenance
                      </option>
                      <option value="Licensing/Permits">
                        Licensing/Permits
                      </option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      name="expense_title"
                      value={recordData.expense_title}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </div>
              </div>
              <Form.Group className="mb-3">
                <Form.Label>Details</Form.Label>
                <Form.Control
                  as="textarea"
                  name="expense_details"
                  value={recordData.expense_details}
                  onChange={handleChange}
                />
              </Form.Group>
              <div className="row">
                <div className="col-md-4">
                  <Form.Group className="mb-3">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      value={recordData.amount}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="mb-3">
                    <Form.Label>Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="date"
                      value={recordData.date}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="mb-3">
                    <Form.Label>Payment Method</Form.Label>
                    <Form.Select
                      name="payment_method"
                      value={recordData.payment_method}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Payment Method</option>
                      <option value="Cash">Cash</option>
                      <option value="Credit Card">Credit Card</option>
                      <option value="Debit Card">Debit Card</option>
                    </Form.Select>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Units/Gallon</Form.Label>
                    <Form.Control
                      type="number"
                      name="units"
                      value={recordData.units}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Odometer</Form.Label>
                    <Form.Control
                      type="number"
                      name="odometer"
                      value={recordData.odometer}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </div>
              </div>
              <Form.Group className="mb-3">
                <Form.Label>Attachment</Form.Label>
                <Form.Control type="file" onChange={handleFileChange} />
              </Form.Group>

              <div className="d-flex justify-content-end mb-3 mt-3">
                <Button
                  variant="secondary"
                  onClick={() => setShowModal(!showModal)}
                  className="me-2"
                >
                  Close
                </Button>
                {
                    expenseLoader === true ?
                    <Spinner/>:
                    <Button variant="primary" type="submit">
                    Save Record
                </Button>
                }
              </div>
            </Form>
          </Modal.Body>
        </Modal>
        {/* ExpenseEditModal */}
        <Modal
          show={showModalEdit}
          style={{zIndex:9999}}
          onHide={() => setShowModalEdit(!showModalEdit)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h6>Edit Record</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmitEdit}>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Category</Form.Label>
                    <Form.Select
                      name="category_title"
                      value={singlerecordData.category_title}
                      onChange={handleChangeEdit}
                      required
                    >
                      <option value="">Select Category</option>
                      <option value="Fuel">Fuel</option>
                      <option value="Maintenance">Maintenance</option>
                      <option value="Repairs">Repairs</option>
                      <option value="Wash">Wash</option>
                      <option value="Tolls">Tolls</option>
                      <option value="Misc">Misc</option>
                      <option value="Preventative Maintenance">
                        Preventative Maintenance
                      </option>
                      <option value="Licensing/Permits">
                        Licensing/Permits
                      </option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      name="expense_title"
                      value={singlerecordData.expense_title}
                      onChange={handleChangeEdit}
                      required
                    />
                  </Form.Group>
                </div>
              </div>
              <Form.Group className="mb-3">
                <Form.Label>Details</Form.Label>
                <Form.Control
                  as="textarea"
                  name="expense_details"
                  value={singlerecordData.expense_details}
                  onChange={handleChangeEdit}
                />
              </Form.Group>
              <div className="row">
                <div className="col-md-4">
                  <Form.Group className="mb-3">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      value={singlerecordData.amount}
                      onChange={handleChangeEdit}
                      required
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="mb-3">
                    <Form.Label>Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="date"
                      value={singlerecordData.date}
                      onChange={handleChangeEdit}
                      required
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="mb-3">
                    <Form.Label>Payment Method</Form.Label>
                    <Form.Select
                      name="payment_method"
                      value={singlerecordData.payment_method}
                      onChange={handleChangeEdit}
                      required
                    >
                      <option value="">Select Payment Method</option>
                      <option value="Cash">Cash</option>
                      <option value="Credit Card">Credit Card</option>
                      <option value="Debit Card">Debit Card</option>
                    </Form.Select>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Units/Gallon</Form.Label>
                    <Form.Control
                      type="number"
                      name="units"
                      value={singlerecordData.units}
                      onChange={handleChangeEdit}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Odometer</Form.Label>
                    <Form.Control
                      type="number"
                      name="odometer"
                      value={singlerecordData.odometer}
                      onChange={handleChangeEdit}
                    />
                  </Form.Group>
                </div>
              </div>
              <Form.Group className="mb-3">
                <Form.Label>Attachment</Form.Label>
                <Form.Control type="file" onChange={handleFileChangeEdit} />
              </Form.Group>

              <div className="d-flex justify-content-end mb-3 mt-3">
                <Button
                  variant="danger"
                  onClick={() => handleDelete(singlerecordData.id)}
                  
                  className="me-2"
                >
                  Delete Expense
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => setShowModalEdit(!showModalEdit)}
                  className="me-2"
                >
                  Close
                </Button>
                {
                    expenseLoader === true ?
                    <Spinner/>:
                    <Button variant="primary" type="submit">
                    Save Changes
                </Button>
                }
              </div>
            </Form>
          </Modal.Body>
        </Modal>
        {/* Schedule Modal */}
        <Modal
          show={scheduleModal}
          onHide={() => setScheduleModal(!scheduleModal)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h6>Add Maintanance Record</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <div className="row">
                
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      name="title"
                      value={scheduleData.title}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </div>
              </div>
              <Form.Group className="mb-3">
                <Form.Label>Details</Form.Label>
                <Form.Control
                  as="textarea"
                  name="details"
                  value={scheduleData.detailing}
                  onChange={handleChange}
                />
              </Form.Group>
              <div className="row">
                <div className="col-md-4">
                  <Form.Group className="mb-3">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      value={scheduleData.amount}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="mb-3">
                    <Form.Label>Schedule Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="date"
                      value={scheduleData.schedule_date}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </div>
               
              </div>
            
              <div className="d-flex justify-content-end mb-3 mt-3">
                <Button
                  variant="secondary"
                  onClick={() => setScheduleModal(!scheduleModal)}
                  className="me-2"
                >
                  Close
                </Button>
                
                <Button variant="primary" type="submit">
                  Save Record
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
         
      </MasterLayout>
     
    </>
  );
};

export default ViewTruckPage;
